module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-window-cd48d08c3d2e66e42386bf4ff8092c46.svg";